import React from "react";

import { Grid, Paper, Typography } from "@material-ui/core";

import { ButtonGeneric } from "../atoms/Buttons";

export const GenericForm = ({
  form,
  style = {},
  center,
  spacing = 1,
  justify,
  alignItems,
  children
}) => {
  return (
    <Grid
      container
      spacing={spacing}
      style={style}
      justify={center ? "center" : justify}
      alignItems={center ? "center" : alignItems}
    >
      { children }
      {form.map((item, index) => {
        const { Component, grid, children = null, separation, ...props } = item;
        if (!children && !separation) {
          return (
            <Grid key={index} style={{textAlign: "center"}} item {...grid}>
              <Component {...props} />
            </Grid>
          );
        } else if (separation) {
          return <Grid key={index} item xs={separation} />;
        } else {
          const { list, title, button } = children;

          return (
            <Grid
              key={index}
              item
              component={Paper}
              elevation={3}
              {...grid}
            >
              <Grid container spacing={spacing} style={{ padding: "0.5em" }}>
                {title && (
                  <Grid item xs={12} style={{textAlign: "center"}}>
                    <Typography variant="button">{title}</Typography>
                  </Grid>
                )}
                {list.map((subItem, subIndex) => {
                  const { SubComponent, subSeparation, subGrid, ...subProps } = subItem;

                  if (subSeparation) {
                    return <Grid key={subIndex} item xs={subSeparation} />;
                  } else {
                    return (
                      <Grid key={subIndex} item {...subGrid} style={{textAlign: "center"}}>
                        <SubComponent {...subProps} />
                      </Grid>
                    );
                  }
                })}
                {button && (
                  <ButtonGeneric 
                    type="button"
                    fullWidth
                    color="primary"
                    text={button.text}
                    disabled={button.disabled}
                    onClick={button.onClick}
                  />
                )}
              </Grid>
            </Grid>
          );
        }
      })}
    </Grid>
  );
};
